import script from "./Customer.vue?vue&type=script&setup=true&lang=ts"
export * from "./Customer.vue?vue&type=script&setup=true&lang=ts"

import "./Customer.vue?vue&type=style&index=0&id=6af71f7e&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6af71f7e"]])

export default __exports__